export var ChainId;
(function (ChainId) {
    ChainId[ChainId["eth"] = 1] = "eth";
    ChainId[ChainId["bnb"] = 56] = "bnb";
    ChainId[ChainId["matic"] = 137] = "matic";
    ChainId[ChainId["op"] = 10] = "op";
    ChainId[ChainId["arbitrum"] = 42161] = "arbitrum";
    ChainId[ChainId["gnosis"] = 100] = "gnosis";
    ChainId[ChainId["avalanche"] = 43114] = "avalanche";
    ChainId[ChainId["fantom"] = 250] = "fantom";
    ChainId[ChainId["aurora"] = 1313161554] = "aurora";
    ChainId[ChainId["klaytn"] = 8217] = "klaytn";
    ChainId[ChainId["zkSyncEra"] = 324] = "zkSyncEra";
    // base
    // linea
})(ChainId || (ChainId = {}));
//# sourceMappingURL=chain-id.js.map